export default "__VITE_ASSET__CdDnn_yA__"